import {
	GET_USER,
	GET_USER_SUCCESS,
	GET_USER_FAIL,
	LOGOUT_USER,
	TOKEN_EXPIRED,
	SET_NURSE_MODE_USER,
	SET_SESSION_CENTER_USER,
	AUTH_USER,
	AUTH_USER_FAIL,
	AUTH_USER_SUCCESS,
	API_RESET_PASSWORD_SUCCESS,
	API_RESET_PASSWORD_FAIL,
	API_PATCH_TOGGLE_NURSE_HELP_SUCCESS,
	API_GET_NURSE_HELP_SUCCESS,
	API_FORGOT_PASSWORD_SUCCESS,
	API_FORGOT_PASSWORD_FAIL,
	API_GET_NEED_HELP_SUCCESS,
	API_PATCH_TOGGLE_NEED_HELP_SUCCESS,
	API_GET_NEED_HELP,
	API_PATCH_TOGGLE_NEED_HELP,
	TOGGLE_HELPFOLDERS_MY_CENTER,
	API_PATCH_SOUND_NOTIFICATION_SUCCESS,
	API_PATCH_TEL_FOR_TVSEC_SUCCESS,
} from "actions/user";
import { DEFAULT_CLIENT, V2_CLIENT } from "config/clientConstants";
import { toast } from "react-toastify";
import { getVersion } from "services/auth";

const payloadAdapter = (action, state, currentClient) => {
	if (action.type === AUTH_USER_SUCCESS && currentClient === DEFAULT_CLIENT) {
		return {
			...state.session,
			token: action.payload.token,
			id: action.payload.id,
			role: action.payload.role,
			rights: action.payload.rights,
			name: action.payload.name,
			gender: action.payload.gender,
			type: null,
			center: null,
			nurse_id: action.payload.nurse_id,
			refreshToken: action.payload.refreshToken,
			resetPassword: action.payload.resetPassword,
			last_password_change: action.payload.last_password_change,
			nurseHelp: action.payload.nurseHelp,
			needHelp: action.payload.needHelp,
			needHelpLoading: false,
			access_centers: action.payload.access_centers,
			access_companies: action.payload.access_companies,
			soundNotification: action.payload.soundNotification,
			myTelForTvSec: action.payload.myTelForTvSec,
		};
	}
	
	if (action.type === AUTH_USER_SUCCESS && currentClient === V2_CLIENT) {
		return {
			...state.session,
			token: action.payload.token,
			id: action.payload.user.id,
			role: action.payload.user.role,
			rights: action.payload.user.rights,
			name: action.payload.user.firstName + ' ' + action.payload.user.lastName,
			gender: action.payload.user.gender,
			type: null,
			center: null,
			nurse_id: action.payload.user.nurseId,
			refreshToken: action.payload.refreshToken,
			resetPassword: action.payload.resetPassword,
			// last_password_change: action.payload.last_password_change,
			nurseHelp: action.payload.user.helpNurse,
			needHelp: action.payload.user.needHelp,
			needHelpLoading: false,
			access_centers: action.payload.accessCenters,
			access_companies: action.payload.accessCompanies,
			soundNotification: action.payload.user.soundNotification,
			myTelForTvSec: action.payload.user.myTelForTvSec,
		};
	}
	
	// Default case - return current session state
	return state.session;
}


const initialState = {
	focus: {},
	session: {
		token: null,
		id: null,
		role: null,
		rights: null,
		name: null,
		gender: null,
		type: null,
		center: null,
		box: null,
		nurse_id: null,
		refreshToken: null,
		resetPassword: null,
		last_password_change: null,
		nurseHelp: null,
		helpFoldersMyCenter: false,
		needHelp: null,
		needHelpLoading: false,
		access_centers: null,
		access_companies: null,
		soundNotification: null,
		themeHospital: false,
		myTelForTvSec: null,
	},
	loading: false,
	hasTubesWaiting: null,
	error: null,
};

export default function user(state = initialState, action) {
	switch (action.type) {
		case TOGGLE_HELPFOLDERS_MY_CENTER:
			return { ...state, session: { ...state.session, helpFoldersMyCenter: !state.session.helpFoldersMyCenter } };
		case GET_USER:
			return { ...state, loading: true };
		case GET_USER_SUCCESS:
			return { ...state, loading: false, focus: action.payload.data };
		case GET_USER_FAIL:
			return {
				...state,
				loading: false,
				error: "Impossible de récupérer les utilisateurs",
			};

		case AUTH_USER:
			return {
				...state,
				loading: true,
				error: null,
				session: {
					...state.session,
					center: null,
				},
			};
		case AUTH_USER_SUCCESS:
			const version = getVersion(AUTH_USER);
			const payload = payloadAdapter(action, state, version.currentClient);
			return { ...state, loading: false, session: payload };
		case SET_NURSE_MODE_USER:
			return {
				...state,
				loading: false,
				session: {
					...state.session,
					type: action.payload,
				},
			};
		case SET_SESSION_CENTER_USER:
			return {
				...state,
				loading: false,
				session: {
					...state.session,
					center: action.payload.center,
					box: action.payload.box,
					themeHospital: action.payload.themeHospital,
				},
			};
		case AUTH_USER_FAIL:
			if (action.payload) {
				const { statusCode } = action.payload;
				return {
					...state,
					loading: false,
					error:
						statusCode === 400
							? "Veuillez remplir tous les champs"
							: statusCode === 401
							? "E-mail ou mot de passe incorrect"
							: "Une erreur s'est produite",
				};
			}
			return {
				...state,
				loading: false,
			};
		case LOGOUT_USER:
			return {
				...state,
				loading: false,
				session: {
					token: null,
					id: null,
					role: null,
					rights: null,
					name: null,
					gender: null,
					type: null,
					center: null,
					nurse_id: null,
					refreshToken: null,
					resetPassword: null,
					last_password_change: null,
				},
			};

		case TOKEN_EXPIRED:
			return {
				...state,
				loading: false,
				session: {
					token: null,
					id: null,
					role: null,
					rights: null,
					name: null,
					gender: null,
					type: null,
					center: null,
					nurse_id: null,
					refreshToken: null,
					resetPassword: null,
					last_password_change: null,
				},
				error: "Votre session a expiré",
			};
		case API_RESET_PASSWORD_SUCCESS:
			toast.success("Mot de passe modifié");
			return {
				...state,
				loading: false,
				session: {
					...state.session,
					resetPassword: false,
					last_password_change: new Date(),
				},
			};
		case API_RESET_PASSWORD_FAIL:
			return {
				...state,
				loading: false,
			};
		case API_FORGOT_PASSWORD_SUCCESS:
			toast.success("Un email vous a été envoyé. Merci de consulter votre boite mail", {
				autoClose: 5000,
				hideProgressBar: false,
			});
			return {
				...state,
				loading: false,
				session: {
					...state.session,
					resetPassword: true,
				},
			};
		case API_FORGOT_PASSWORD_FAIL:
			toast.error("Aucun compte MyLabNurse n'est attaché à cet identifiant ou cette adresse email.");
			return {
				...state,
				loading: false,
			};
		case API_GET_NURSE_HELP_SUCCESS:
			return {
				...state,
				session: {
					...state.session,
					nurseHelp: action.payload.data,
				},
			};
		case API_PATCH_TOGGLE_NURSE_HELP_SUCCESS:
			return {
				...state,
				session: {
					...state.session,
					nurseHelp: action.payload.data,
				},
			};
		case API_GET_NEED_HELP:
			return { ...state, session: { ...state.session, needHelpLoading: true } };
		case API_PATCH_TOGGLE_NEED_HELP:
			return { ...state, session: { ...state.session, needHelpLoading: true } };
		case API_GET_NEED_HELP_SUCCESS:
			return {
				...state,
				session: {
					...state.session,
					needHelp: action.payload.data,
					needHelpLoading: false,
				},
			};
		case API_PATCH_TOGGLE_NEED_HELP_SUCCESS:
			return {
				...state,
				session: {
					...state.session,
					needHelp: action.payload.data,
					needHelpLoading: false,
				},
			};
		case API_PATCH_SOUND_NOTIFICATION_SUCCESS:
			return {
				...state,
				session: {
					...state.session,
					soundNotification: action.payload.data.soundNotification,
				},
			};
		case API_PATCH_TEL_FOR_TVSEC_SUCCESS:
			return {
				...state,
				session: {
					...state.session,
					myTelForTvSec: action.payload.data.myTelForTvSec,
				},
			};
		default:
			return state;
	}
}
